import React from "react";

import AllStore from "../logic/AllStore";
import Router from "../logic/Router";
import stepData from "../step-data.json";
import Manager from "./Manager";
import Page from "../../components/common/Page";

class ByosRoot extends React.Component {
  constructor(props) {
    super(props);
    this.store = new AllStore(stepData);
    this.router = new Router(this.store);
  }

  render() {
    return (
      <Page header={false} newsletterForm={false}>
        <Manager store={this.store} />
      </Page>
    );
  }
}
export default ByosRoot;



// WEBPACK FOOTER //
// ./src/byos/component/ByosRoot.js